import { TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core'
import { TRANSLATE_EN, TRANSLATE_PL } from '@translate/files'
import { Observable, of } from 'rxjs'
import { AppLanguages } from '../../shared/constants/enums'

export class OwnTranslateLoader implements TranslateLoader {
    getTranslation(lang: AppLanguages): Observable<any> {
        switch (lang) {
            case AppLanguages.EN:
                return of(TRANSLATE_EN)
            default:
                return of(TRANSLATE_PL)
        }
    }
}

export const TRANSLATE_CONFIG: TranslateModuleConfig = {
    defaultLanguage: AppLanguages.PL,
    loader: {
        provide: TranslateLoader,
        useClass: OwnTranslateLoader
    }
}
